<style>
.sm-list .btn {
  width: 37px;
  height: 16px;
  padding: 0;
  margin-right: 6px;
}
</style>
<style scoped>
div {
  box-sizing: border-box;
}

.center-word {
  display: flex;
  justify-content: space-between;
  padding-top: 31px;
  margin-bottom: 49px;
}

.title {
  font-size: 16px;
  color: #1a1a1a;
}

img {
  width: 100%;
  height: 100%;
  display: block;
}

.center-l {
  width: 300px;
  background: #fff;
  height: 640px;
  border: 1px solid #e4e4e4;
}

.my-title {
  display: flex;
  border-bottom: 1px solid #e2e2e2;
  height: 60px;
  box-sizing: border-box;
  align-items: center;
  padding-left: 21px;
}

.img {
  width: 24px;
  height: 24px;
  margin-right: 6px;
}

.mymsg-box {
  padding-top: 24px;
  padding-bottom: 49px;
  border-bottom: 1px solid #eee;
}

.my-headerimg {
  width: 84px;
  height: 84px;
  border-radius: 50%;
  margin: 0 auto;
  /* background: chocolate; */
  margin-bottom: 18px;
  border: 1px solid #e4e4e4;
  overflow: hidden;
}

.username {
  font-size: 16px;
  color: #333333;
  font-weight: bold;
  margin-bottom: 11px;
}

.address {
  font-size: 12px;
  color: #bbbbbb;
  margin-bottom: 10px;
}

.country {
  padding-right: 11px;
  border-right: 1px solid #bbb;
  margin-right: 11px;
}

.level {
  /* width: 104px; */
  height: 20px;
  border-radius: 10px;
  background-image: linear-gradient(#fdc4a7, #eda584);
  font-size: 13px;
  color: #bd5829;
  text-align: center;
  line-height: 20px;
  margin: 0 auto;
  padding: 5px 10px;
}

.center-r {
  width: 888px;
}

.center-l-item {
  height: 54px;
  line-height: 54px;
  font-size: 14px;
  color: #131313;
  text-align: center;
  border-bottom: 1px solid #eee;
}

.center-l-item:hover {
  cursor: pointer;
}

.center-l-item.font-red {
  color: #ee4847;
  border-bottom: 0;
}

.my-order {
  background: #fff;
  padding-bottom: 24px;
}

.top-list {
  display: flex;
  justify-content: space-between;
  padding: 0 19px;
  height: 59px;
  border-bottom: 1px solid #e2e2e2;
  align-items: center;
}

.top-list-l {
  display: flex;
}

.sm-boxs {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sm-box-item {
  width: 439px;
  background: #fff;
  margin-bottom: 10px;
  border: 1px solid #e4e4e4;
  box-sizing: border-box;
}

.top-list-r {
  display: flex;
  align-items: center;
}

.top-list-r .btn {
  height: 30px;
  line-height: 30px;
  text-align: center;
  color: #666666;
  font-size: 14px;
  border-radius: 15px;
  background: #fff;
  padding: 0 10px;
}

.top-list-r .btn.order {
  background: #0082dd;
  color: #fff;
}

.more-img {
  width: 10px;
  height: 10px;
  margin-left: 5px;
}

.box-msg {
  /* height: 122px; */
}

.sm-list {
  height: 40px;
  line-height: 40px;
  /* border-bottom: 1px solid #E2E2E2; */
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.sm-list-l {
  width: 75%;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-size: 13px;
}

.sm-list-l.la-l {
  width: 55%;
}

.sm-list-r {
  width: 40%;
  text-align: right;
  display: block;
  color: #1680d4;
  font-size: 13px;
}

.sm-list-r.la-r {
  width: 40%;
  color: #999999;
}

.sm-boxs .box-msg {
  height: 122px;
}

.center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.yue_box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.box-msg-l,
.box-msg-r {
  width: 50%;
}

.box-msg-l {
  border-right: 1px solid #bbbbbb;
}

.box-msg-l span,
.box-msg-r span {
  font-size: 16px;
  color: #666;
}

.box-msg-r span.cour {
  font-size: 30px;
  color: #1a1a1a;
  font-weight: bold;
  margin-left: 11px;
}

.box-msg-l span.yue-money {
  font-size: 30px;
  color: #e54746;
  font-weight: bold;
  margin-left: 15px;
}

.la_box {
  height: 110px;
  /* height: 100%; */
  font-size: 16px;
  color: #666666;
  padding: 0 23px;
}

.blue {
  color: #258cdd;
}

.massage {
  padding: 0 25px;
  margin-top: 26px;
}

.table {
  width: 825px;
  border: 1px solid #e2e2e2;
}

.table-title {
  background: #e2e2e2;
  height: 40px;
  text-align: left;
  display: flex;
}

.goods-name {
  font-size: 14px;
  color: #333;
  line-height: 40px;
}

.goods-msg {
  height: 116px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #e2e2e2;
  box-sizing: border-box;
  text-align: left;
}

.goods-msg:last-child {
  border: 0;
}

.fir-name {
  padding-left: 137px;
  width: 362px;
}

.goods-img {
  width: 137px;
}

.goods-img-box {
  width: 80px;
  height: 80px;
  margin: 0 auto;
  margin-bottom: 8px;
}

.goods-detail {
  width: 225px;
}

.font1 {
  font-size: 18px;
  color: #000;
  margin-bottom: 16px;
  width: 95%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.font2 {
  font-size: 14px;
  color: #666;
  width: 95%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.goods-price {
  font-size: 18px;
  color: #d03b3b;
  font-weight: bold;
  width: 158px;
}

.se-name {
  width: 158px;
}

.th-name {
  width: 111px;
}

.goods-name.la-name {
  text-align: center;
}

.la-name {
  width: 180px;
}

.goods-state {
  width: 111px;
  color: #137ed3;
}

.goods-state.color {
  color: #d03b3b;
}

.goods-btn {
  display: flex;
  justify-content: space-around;
  width: 180px;
}

.goods-btn > a {
  width: 88px;
  height: 30px;
  text-align: center;
  line-height: 30px;
}

.pay {
  background-image: linear-gradient(#3f9fea, #0a77ce);
  color: #fff;
}

.dele-order {
  background: #fff;
  border: 1px solid #0a77ce;
  box-sizing: border-box;
}

.se-contnet {
  height: 159px;
}

.have-msg {
  height: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}

.collection-mine-box {
  display: flex;
  justify-content: space-around;
  padding: 0 10px;
}
</style>

<template>
  <div id="menber-center" v-cloak>
    <HeaderTopView></HeaderTopView>
    <WNav></WNav>
    <div class="word center-word">
      <!-- 我的信息 -->
      <div class="center-l">
        <div class="my-title">
          <div class="img">
            <img src="@/assets/images/icon2.png" alt />
          </div>
          <div class="title">{{ $t("vip.Account") }}</div>
        </div>
        <div class="mymsg-box">
          <div class="my-headerimg">
            <img
              :src="
                mydata.headImage ? mydata.headImage : '@/assets/images/h.png'
              "
              alt
            />
          </div>
          <div class="username">
            {{
              mydata.country
                ? mydata.country == "中国"
                  ? mydata.surname + mydata.name
                  : mydata.name + mydata.surname
                : "FSOM"
            }}
          </div>
          <div class="address">
            <span class="country">{{
              mydata.country ? mydata.country : "-"
            }}</span>
            <span>{{ mydata.country ? mydata.provinces : "-" }}</span>
          </div>
          <span class="level"
            >{{ $t("vip.vip") }}:{{ mydata.country ? mydata.grade : "-" }}</span
          >
        </div>
        <div class="center-l-item" @click="secondPage(1)">
          {{ $t("vip.Receiving") }}
        </div>
        <div class="center-l-item" @click="secondPage(0)">
          {{ $t("vip.personal") }}
        </div>
        <div class="center-l-item" @click="secondPage(2)">
          {{ $t("vip.Change") }}
        </div>
        <div class="center-l-item" @click="secondPage(3)">
          {{ $t("vip.Changezf") }}
        </div>
        <div class="center-l-item" @click="secondPage(4)">
          {{ $t("vip.billingRecord") }}
        </div>
        <div class="center-l-item font-red" @click="outLogin" v-if="token">
          {{ $t("vip.out") }}
        </div>
      </div>

      <!-- 右边详情 -->
      <div class="center-r">
        <!-- 我的订单 -->
        <div class="my-order">
          <div class="top-list">
            <div class="top-list-r">
              <div
                class="btn"
                @click="changeOrder(0)"
                :class="{ order: orderType == 0 }"
              >
                {{ $t("vip.finished") }}
              </div>
              <div
                class="btn"
                @click="changeOrder(1)"
                :class="{ order: orderType == 1 }"
              >
                {{ $t("vip.sample") }}
              </div>
              <div
                class="btn"
                @click="changeOrder(2)"
                :class="{ order: orderType == 2 }"
              >
                {{ $t("vip.customized") }}
              </div>
            </div>
            <div class="top-list-r" @click="jumpToAllOrder">
              <span>{{ $t("vip.whole") }}</span>
              <div class="more-img">
                <img src="@/assets/images/icon-m.png" alt />
              </div>
            </div>
          </div>
          <div class="box-msg table-box">
            <div class="massage" v-if="orderList.length != 0">
              <div class="table">
                <div class="table-title">
                  <div class="goods-name fir-name">{{ $t("vip.shop") }}</div>
                  <div class="goods-name se-name">
                    {{ $t("vip.Price")
                    }}{{ orderType == 1 ? `(${$t("shopDet.integral")})` : "" }}
                  </div>
                  <div class="goods-name th-name">{{ $t("vip.type") }}</div>
                  <div class="goods-name la-name">{{ $t("vip.edit") }}</div>
                </div>

                <div
                  class="goods-msg"
                  v-for="(item, index) in orderList"
                  :key="index"
                >
                  <div class="goods-img">
                    <div class="goods-img-box" v-if="orderType == 0">
                      <img
                        :src="
                          item.productImg ? item.productImg.split(',')[0] : ''
                        "
                        alt=""
                      />
                    </div>
                    <div class="goods-img-box" v-if="orderType == 1">
                      <img
                        :src="
                          item.params
                            ? item.params.productImg.split(',')[0]
                            : ''
                        "
                        alt=""
                      />
                    </div>
                    <div class="goods-img-box" v-if="orderType == 2">
                      <img src="@/assets/images/pro.png" alt="" />
                    </div>
                  </div>
                  <div class="goods-detail">
                    <!-- 成品 -->
                    <div v-if="orderType == 0">
                      <div class="font1">{{ item.productName }}</div>
                      <div class="font2">
                        {{ $t("vip.number") }}：{{ item.orderNo }}
                      </div>
                      <div class="font2">
                        {{ $t("vip.num") }}： {{ item.num ? item.num : 0 }}
                      </div>
                    </div>
                    <!-- 样品 -->
                    <div v-if="orderType == 1">
                      <div class="font1">
                        {{ item.params ? item.params.productName : "" }}
                      </div>
                      <div class="font2">
                        {{ $t("vip.number") }}：{{
                          item.params ? item.params.productNum : ""
                        }}
                      </div>
                      <div class="font2">{{ $t("vip.num") }}： 1</div>
                    </div>
                    <!-- 定制 -->
                    <div v-if="orderType == 2">
                      <div class="font1">{{ item.productName }}</div>
                      <div class="font2">
                        {{ $t("vip.number") }}：{{ item.orderNo }}
                      </div>
                      <div class="font2">
                        {{ $t("vip.num") }}： {{ item.demandQuantity }}
                      </div>
                    </div>
                  </div>

                  <!-- 成品 -->
                  <div class="goods-price" v-if="orderType == 0">
                    {{ `${$type == 1 ? "￥" : "$"}` + item.moneyNum / 100 }}
                  </div>
                  <div
                    class="goods-state"
                    :class="item.proOrderState == 1 ? 'color' : ''"
                    v-if="orderType == 0"
                  >
                    {{
                      item.proOrderState == 1
                        ? $t("state.payment")
                        : item.proOrderState == 2
                        ? $t("state.delivergoods")
                        : item.proOrderState == 3
                        ? $t("state.Distribution")
                        : item.proOrderState == 4
                        ? $t("state.Completed")
                        : $t("state.close")
                    }}
                  </div>
                  <div class="goods-btn" v-if="orderType == 0">
                    <a
                      href="javascript:void(0)"
                      class="pay"
                      v-if="item.proOrderState == 1"
                      :data-idex="index"
                      @click="linkToPay($event)"
                      >{{ $t("vip.payment") }}</a
                    >
                    <a
                      href="javascript:void(0)"
                      class="dele-order"
                      @click="cancelOrder(index, 'standard')"
                      v-if="item.proOrderState == 1"
                      >{{ $t("vip.cancel") }}</a
                    >
                  </div>

                  <!-- 样品 -->
                  <div class="goods-price" v-if="orderType == 1">
                    {{ item.integralNum }}
                  </div>
                  <div class="goods-state" v-if="orderType == 1">
                    {{
                      item.orderState === 0
                        ? $t("state.toexamine")
                        : item.orderState === 1
                        ? $t("state.delivergoods")
                        : item.orderState === 2
                        ? $t("state.Receipt")
                        : item.orderState === 3
                        ? $t("state.Receivedgoods")
                        : item.orderState === 4
                        ? $t("state.Rejected")
                        : $t("state.Cancelled")
                    }}
                  </div>
                  <div class="goods-btn" v-if="orderType == 1">
                    <a
                      href="javascript:void(0)"
                      class="dele-order"
                      v-if="item.orderState == 0"
                      >{{ $t("vip.cancel") }}</a
                    >
                  </div>

                  <!-- 定制 -->
                  <div class="goods-price" v-if="orderType == 2">
                    {{
                      `${$type == 1 ? "￥" : "$"}` +
                      (item.totalAmount ? item.totalAmount : 0)
                    }}
                  </div>
                  <div
                    class="goods-state"
                    :class="item.orderState == 4 ? 'color' : ''"
                    v-if="orderType == 2"
                  >
                    {{
                      item.orderState == 1
                        ? $t("state.upload")
                        : item.orderState == 2
                        ? $t("state.htToexamine")
                        : item.orderState == 3
                        ? $t("state.setup")
                        : item.orderState == 4
                        ? $t("state.payment")
                        : item.orderState == 5
                        ? $t("state.delivergoods")
                        : item.orderState == 6
                        ? $t("state.htreject")
                        : item.orderState == 7
                        ? $t("state.ddreject")
                        : item.orderState == 8
                        ? $t("state.Completed")
                        : item.orderState == 9
                        ? $t("state.Cancelled")
                        : $t("state.toexamine")
                    }}
                  </div>
                  <div class="goods-btn" v-if="orderType == 2">
                    <a
                      href="javascript:void(0)"
                      class="pay"
                      v-if="item.orderState == 4"
                      >{{ $t("vip.payment") }}</a
                    >
                    <a
                      href="javascript:void(0)"
                      class="dele-order"
                      @click="cancelOrder(index, 'sample')"
                      v-if="item.orderState == 1 || item.orderState == 0"
                      >{{ $t("vip.cancel") }}</a
                    >
                  </div>
                </div>
              </div>
            </div>
            <div v-else style="height: 100px; line-height: 100px">
              {{ $t("vip.available") }}
            </div>
          </div>
        </div>

        <div class="sm-boxs">
          <!-- 我的消息 -->
          <div class="sm-box-item">
            <div class="top-list">
              <div class="top-list-l">
                <div class="img">
                  <img src="@/assets/images/icon4.png" alt />
                </div>
                <span class="title">{{ $t("vip.news") }}</span>
              </div>
              <div
                class="top-list-r"
                @click="() => $router.push('/mine/message')"
              >
                <span>{{ $t("vip.whole") }}</span>
                <div class="more-img">
                  <img src="@/assets/images/icon-m.png" alt />
                </div>
              </div>
            </div>
            <div class="la_box" :class="myMsg.length == 0 ? 'center' : ''">
              <div v-if="myMsg.length != 0">
                <div
                  v-for="(item, index) in myMsg"
                  :key="index"
                  class="sm-list"
                >
                  <el-button
                    type="primary"
                    plain
                    size="mini"
                    v-if="item.orderNo"
                    class="btn"
                  >
                    {{ $t("vip.order") }}</el-button
                  >
                  <el-button type="warning" plain size="mini" v-else class="btn"
                    >{{ $t("vip.system") }}
                  </el-button>
                  <span class="sm-list-l la-l">{{ item.messageContent }}</span>
                  <span class="sm-list-r la-r">{{ item.createTime }}</span>
                </div>
              </div>
              <div v-else>{{ $t("vip.available") }}</div>
            </div>
          </div>

          <!-- 账户余额 -->
          <div class="sm-box-item">
            <div class="top-list">
              <div class="top-list-l">
                <div class="img">
                  <img src="@/assets/images/icon5.png" alt />
                </div>
                <span class="title">{{ $t("vip.balance") }}</span>
              </div>
              <div class="top-list-r" @click="accountBalanceFn">
                <span>{{ $t("vip.whole") }}</span>
                <div class="more-img">
                  <img src="@/assets/images/icon-m.png" alt />
                </div>
              </div>
            </div>
            <div class="box-msg yue_box">
              <div class="box-msg-l">
                <span>{{ $t("vip.balances") }}</span>
                <span class="yue-money">{{
                  `${$type == 1 ? "￥" : "$"}` + accountBalance
                }}</span>
              </div>
              <div class="box-msg-r">
                <span>{{ $t("vip.integral") }}</span>
                <span class="cour">{{ integralBalance }}</span>
              </div>
            </div>
          </div>

          <!-- 我的足迹 -->
          <div class="sm-box-item">
            <div class="top-list">
              <div class="top-list-l">
                <div class="img">
                  <img src="@/assets/images/icon6.png" alt />
                </div>
                <span class="title">{{ $t("vip.footprint") }}</span>
              </div>
              <div class="top-list-r" @click="myFootstep">
                <span>{{ $t("vip.whole") }}</span>
                <div class="more-img">
                  <img src="@/assets/images/icon-m.png" alt />
                </div>
              </div>
            </div>
            <!-- 足迹详情 -->
            <div class="se-contnet">
              <div class="have-msg la_box">
                <template v-if="footprintAll.length != 0">
                  <div
                    class="footstep-box"
                    v-for="(item, index) in footprintAll"
                    :key="index"
                  >
                    <div class="goods-img-box">
                      <img
                        :src="
                          item.params.productImg
                            ? $img + item.params.productImg.split(',')[0]
                            : ''
                        "
                        alt=""
                      />
                    </div>
                    <div>
                      {{ item.params ? item.params.productName : "--" }}
                    </div>
                  </div>
                </template>
                <div v-else>{{ $t("vip.available") }}</div>
              </div>
            </div>
          </div>

          <!-- 我的收藏 -->
          <div class="sm-box-item">
            <div class="top-list">
              <div class="top-list-l">
                <div class="img">
                  <img src="@/assets/images/icon7.png" alt />
                </div>
                <span class="title">{{ $t("vip.Collection") }}</span>
              </div>
              <div
                class="top-list-r"
                @click="() => $router.push('/collection/all')"
              >
                <span>{{ $t("vip.whole") }}</span>
                <div class="more-img">
                  <img src="@/assets/images/icon-m.png" alt />
                </div>
              </div>
            </div>
            <div class="se-contnet">
              <div class="have-msg collection-mine-box la_box">
                <template v-if="collectionAll.length != 0">
                  <div
                    class="footstep-box"
                    v-for="(item, index) in collectionAll"
                    :key="index"
                  >
                    <div class="goods-img-box">
                      <img
                        :src="
                          item.params && item.params.productImg
                            ? item.params.productImg.split(',')[0]
                            : '../../assets/images/icon1.png'
                        "
                        alt=""
                      />
                    </div>
                    <div>
                      {{ item.params ? item.params.productName : "--" }}
                    </div>
                  </div>
                  <div
                    v-if="collectionAll.length < 3"
                    class="footstep-box"
                  ></div>
                </template>
                <div v-else>{{ $t("vip.available") }}</div>
              </div>
            </div>
          </div>
          <!-- 我的项目 -->
          <div class="sm-box-item">
            <div class="top-list">
              <div class="top-list-l">
                <div class="img">
                  <img src="@/assets/images/icon1.png" alt />
                </div>
                <span class="title">{{ $t("vip.project") }}</span>
              </div>
              <div class="top-list-r" @click="myProject">
                <span>{{ $t("vip.whole") }}</span>
                <div class="more-img">
                  <img src="@/assets/images/icon-m.png" alt />
                </div>
              </div>
            </div>

            <div class="la_box" :class="myPro.length == 0 ? 'center' : ''">
              <div v-if="myPro.length != 0">
                <div
                  v-for="(item, index) in myPro"
                  :key="index"
                  class="sm-list"
                >
                  <span class="sm-list-l">{{ item.projectName }}</span>
                  <span class="sm-list-r">{{
                    item.projectState == 0
                      ? $t("state.Submit")
                      : item.projectState == 1
                      ? $t("state.Underreview")
                      : item.projectState == 2
                      ? $t("state.Passed")
                      : $t("state.Rejected")
                  }}</span>
                </div>
              </div>
              <div v-else>{{ $t("vip.available") }}</div>
            </div>
          </div>
          <!-- 远程技术支持 -->
          <div class="sm-box-item">
            <div class="top-list">
              <div class="top-list-l">
                <div class="img">
                  <img src="@/assets/images/icon8.png" alt />
                </div>
                <span class="title">{{ $t("vip.technology") }}</span>
              </div>
              <div
                class="top-list-r"
                @click="() => $router.push('/remote/technology')"
              >
                <span>{{ $t("vip.whole") }}</span>
                <div class="more-img">
                  <img src="@/assets/images/icon-m.png" alt />
                </div>
              </div>
            </div>
            <div class="la_box" :class="remote.length == 0 ? 'center' : ''">
              <div v-if="remote.length != 0">
                <div
                  v-for="(item, index) in remote"
                  :key="index"
                  class="sm-list"
                >
                  <span class="sm-list-l">{{ item.remark1 }}</span>
                  <span class="sm-list-r">{{
                    item.communication == 1
                      ? $t("technology.video")
                      : item.communication == 2
                      ? $t("technology.tel")
                      : item.communication == 3
                      ? $t("technology.communicate")
                      : ""
                  }}</span>
                </div>
              </div>
              <div v-else>
                {{ $t("vip.no_project") }}，
                <span
                  class="blue"
                  @click="() => $router.push('/remote/technology')"
                  >{{ $t("vip.launch") }}，</span
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <PayOkConfirm
        v-if="loadingPay"
        @click-emit-reload="clickBtn"
      ></PayOkConfirm>
    </div>
    <FooterModle></FooterModle>
  </div>
</template>
<script>
import HeaderTopView from "@/components/assembly/HeaderTop.vue"; //头部模块
import WNav from "../assembly/WhiteNav";
import LoginPop from "@/components/assembly/LoginPop.vue"; //登录弹窗
import FooterModle from "../assembly/Footer";
import PayOkConfirm from "../assembly/PayOkConfirm";

export default {
  components: {
    HeaderTopView,
    WNav,
    LoginPop,
    FooterModle,
    PayOkConfirm,
  },
  data() {
    return {
      orderType: 0,
      mydata: {},
      popShow: false,
      footprintAll: [],
      collectionAll: [],
      myMsg: [], //我的消息
      integralBalance: 0, //积分
      accountBalance: 0, //余额
      remote: [], //远程技术
      myPro: [], //我的项目
      pageSize: 2, //我的项目，远程支持页数量
      pageNum: 1,
      orderList: [],
      token: "",
      loadingPay: false,
    };
  },
  methods: {
    //支付成功与否的反馈
    clickBtn() {
      this.loadingPay = false;
      this.myOrder(this.token);
    },
    //退出登录
    outLogin() {
      this.$confirm(this.$t("Tips.out"), this.$t("Tips.Tips"), {
        confirmButtonText: this.$t("Tips.confirm"),
        cancelButtonText: this.$t("Tips.cancel"),
        type: "warning",
      })
        .then(() => {
          let url = "/api/user/loginOut";
          let data = {
            token: this.token,
          };
          this.$post(url, data).then((res) => {
            if (res.code == 0) {
              this.$message({
                message: this.$t("Tips.outsuc"),
                type: "success",
              });
              sessionStorage.clear();
              this.$router.push("/");
            }
          });
        })
        .catch(() => {});
    },
    //立即付款的实现
    linkToPay(e) {
      let idex = Number(e.target.dataset["idex"]);
      if (isNaN(idex) || idex >= this.orderList.length) return;
      let data = this.orderList[idex];
      this.$confirm(this.$t("order.title"), this.$t("order.title"))
        .then(() => {
          //组装数据传入支付页面
          let routerData = {
            payAmount: data.moneyNum,
            zhMoney: data.moneyNumZh,
            orderNo: data.orderNo,
            pageName: "成品订单支付",
            orderType: this.orderType, //成品订单
          };
          this.loadingPay = true;
          //显示弹窗
          sessionStorage.setItem("paydatainfo", JSON.stringify(routerData));
          let routerLinkData = this.$router.resolve({
            path: "/payPage",
          });
          window.open(routerLinkData.href, "_blank");
        })
        .catch((res) => {
          console.log(res, "取消支付");
        });
      e.cancelBubble = true;
    },
    jumpToAllOrder() {
      this.$router.push("/all/order");
    },
    changeOrder(i) {
      this.orderType = i;
      let token = sessionStorage.getItem("token");
      if (i == 0) {
        //成品
        this.myOrder(token);
      } else if (i == 1) {
        //样品
        this.$get("/api/order/query/simple/order", {
          token,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        }).then((res) => {
          this.orderList = res.data;
        });
      } else {
        //定制
        this.$get("/api/customized/order/list", {
          token,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        }).then((res) => {
          this.orderList = res.data;
        });
      }
    },
    //取消订单
    cancelOrder(index = -1, type = "") {
      this.$confirm(this.$t("Tips.qxordersuc"), this.$t("Tips.Tips"))
        .then(() => {
          this.cancelOrderImplements(index, type);
        })
        .catch(() => {});
    },
    //取消订单的方法实现
    cancelOrderImplements(index = -1, type = "") {
      let url, data;
      if (type === "standard") {
        url = "api/standard/order/cancel/order";
        data = {
          orderNo: this.orderList[index].orderNo,
          token: this.token,
        };
      } else if (type === "sample") {
        url = "/api/customized/order/cancel";
        data = {
          orderNo: this.orderList[index].orderNo,
          state: 2,
          token: this.token,
        };
      }
      if (!data || !url) return;
      this.$post(url, data).then((res) => {
        if (res.code === 0) {
          this.$message({
            type: "success",
            message: this.$t("Tips.qxsuc"),
          });
          this.myOrder(this.token);
          return;
        }
        this.$message({
          type: "warning",
          message: "取消失败",
        });
      });
    },
    //是否登录
    islogin() {
      let token = sessionStorage.getItem("token");

      if (token) {
        //我的余额
        this.$get("/api/account/getAccountAll", {
          token: token,
        }).then((res) => {
          this.accountBalance =
            (res.data.accountBalance / 100).toFixed(2) || "0.00";
          this.integralBalance =
            res.data.integralBalance / 10000 > 1
              ? Number(
                  (res.data.integralBalance / 10000)
                    .toString()
                    .match(/^\d+(?:\.\d{0,2})?/)
                ) + this.$t("vip.Company")
              : res.data.integralBalance;
        });
        //用户信息
        this.$get("/api/user/getUserAll", {
          token: token,
        }).then((res) => {
          if (res.code == 0) {
            this.mydata = res.data;
            let grade = res.params.grades; //等级名称
            grade.forEach((element) => {
              if (res.data.grade == element.dictValue) {
                this.mydata.grade = element.dictLabel;
              }
            });
          } else if (res.code == 5000) {
            this.popShow = true;
          }
        });
        //远程技术
        this.$get("/api/remote/support/remoteSupportList", {
          token: token,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        }).then((res) => {
          this.remote = res.data;
        });
        //足迹
        this.$get("/api/footprint/getFootprintAll", {
          token: token,
          pageNum: 1,
          pageSize: 3,
        }).then((res) => {
          if (res.code == 0) {
            this.footprintAll = res.data;
          } else if (res.data == 5000) {
            this.popShow = true;
          }
        });
        //我的项目
        this.$get("/api/myProject/myProjectList", {
          token: token,
          pageSize: this.pageSize,
          pageNum: this.pageNum,
        }).then((res) => {
          this.myPro = res.data;
        });

        //收藏
        this.$get("/api/productCollection/getProductCollectionAll", {
          token: token,
          pageNum: 1,
          pageSize: 3,
        }).then((res) => {
          if (res.code === 0) {
            this.collectionAll = res.data;
          } else if (res.data === 5000) {
            this.popShow = true;
          }
        });
        //我的消息
        this.$get("/api/message/other/list", {
          token: token,
          pageNum: this.pageNum,
          pageSize: 3,
        }).then((res) => {
          this.myMsg = res.data;
        });
        //我的订单
        this.myOrder(token);
      } else {
        //未登录
        this.$showNotFoundLoginComponent();
      }
    },
    closePopFn(i) {
      this.popShow = !i;
    },
    //我的订单
    myOrder(token) {
      this.$get("/api/standard/order/list", {
        token: token,
        pageNum: this.pageNum,
        pageSize: this.pageSize,
      }).then((res) => {
        this.orderList = res.data;
      });
    },
    //跳详细信息
    secondPage(i) {
      let token = sessionStorage.getItem("token");
      if (token) {
        this.$router.push({
          path: "/memberCenterDetail",
          query: {
            i: i,
          },
        });
      } else {
        //未登录
        this.popShow = true;
      }
    },

    accountBalanceFn() {
      let token = sessionStorage.getItem("token");
      if (token) {
        this.$router.push({
          path: "/balance/MyBalance",
        });
      } else {
        //未登录
        this.popShow = true;
      }
    },
    //我的项目
    myProject() {
      let token = sessionStorage.getItem("token");
      if (token) {
        this.$router.push({
          path: "/myProject/MyProject",
        });
      } else {
        //未登录
        this.popShow = true;
      }
    },
    myFootstep() {
      let token = sessionStorage.getItem("token");
      if (token) {
        this.$router.push({
          path: "/footPrint/all",
        });
      } else {
        this.popShow = true;
      }
    },
  },
  mounted() {
    this.token = sessionStorage.getItem("token");
    this.islogin();
  },
};
</script>



// WEBPACK FOOTER //
// src/components/memberCenter/MemberCenter.vue